<script setup lang="ts">
import { cn } from "@/lib/utils";
import { reactiveOmit } from "@vueuse/core";
import {
  PopoverContent,
  type PopoverContentEmits,
  type PopoverContentProps,
  PopoverPortal,
  useForwardPropsEmits,
} from "reka-ui";
import type { HTMLAttributes } from "vue";

type Props = PopoverContentProps & {
  class?: HTMLAttributes["class"];
  portalTo?: string | HTMLElement;
};

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(
  defineProps<Props>(),
  {
    align: "center",
    sideOffset: 4,
    portalTo: "body",
  }
);
const emits = defineEmits<PopoverContentEmits>();

const delegatedProps = reactiveOmit(props, "class", "portalTo");

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <PopoverPortal :to="portalTo">
    <PopoverContent
      v-bind="{ ...forwarded, ...$attrs }"
      :class="
        cn(
          'z-[999999] rounded border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
          props.class
        )
      "
    >
      <!-- <div
        class="absolute w-3 h-3 bg-popover border border-t-0 border-l-0 rotate-45"
        :class="{
          'top-[-6px] left-1/2 -translate-x-1/2': forwarded.side === 'bottom',
          'bottom-[-6px] left-1/2 -translate-x-1/2': forwarded.side === 'top',
          'left-[-6px] top-1/2 -translate-y-1/2': forwarded.side === 'right',
          'right-[-6px] top-1/2 -translate-y-1/2': forwarded.side === 'left',
        }"
      /> -->
      <slot />
    </PopoverContent>
  </PopoverPortal>
</template>
